import React from "react";
import ProductType from "../../../common/interfaces/enums/ProductType";
import SortBy from "../../enums/SortBy";
import { IDropdownOption } from "../../../common/interfaces/IDropdownOption";
import Dropdown from "../../../common/components/Forms/Dropdown/Dropdown";
import cx from "classnames";

interface ISortBySummaryProps {
    productType: ProductType | ProductType[];
    numberOfPolicies: number;
    sortBy: SortBy;
    isDisabled?: boolean;
    handleChangeSortBy: (newSortBy: SortBy) => void;
    dropdownInlineLabel?: string | React.ReactNode;
    component?: "dropdown" | "summary";
}

const sortByDropdown: IDropdownOption<SortBy>[] = [
    {
        label: "Lowest Price",
        value: SortBy.LowestPrice
    },
    {
        label: "Highest Price",
        value: SortBy.HighestPrice
    },
    {
        label: "Most Popular",
        value: SortBy.MostPopular
    },
    // {
    //     label: "Policy Features",
    //     value: SortBy.PolicyFeatures
    // },
    {
        label: "Customer Service",
        value: SortBy.CustomerService
    },
    {
        label: "Financial Strength",
        value: SortBy.FinancialStrength
    }
];

const SortBySummary: React.FC<ISortBySummaryProps> = (props) => {
    const {
        sortBy,
        numberOfPolicies,
        handleChangeSortBy,
        dropdownInlineLabel,
        component
    } = props;

    const productList = Array.isArray(props.productType)
        ? props.productType
        : [props.productType];

    const renderProductsText = (productList: ProductType[]): string => {
        const finalIndex = productList.length - 1;

        return (
            productList.reduce(
                (previousValue, currentValue, index, array) =>
                    previousValue +
                    (index === finalIndex && array.length > 1
                        ? " and "
                        : index > 0
                        ? ", "
                        : "") +
                    currentValue,
                ""
            ) + ` policies`
        );
    };

    if (component == "dropdown" && !!dropdownInlineLabel) {
        return (
            <Dropdown
                name="productPageSortBy"
                selectedOptionId={sortBy}
                options={sortByDropdown}
                onChange={(i) => handleChangeSortBy(i.target.value as SortBy)}
                inlineLabel={dropdownInlineLabel}
                noMargin
            />
        );
    }

    if (component == "summary") {
        return (
            <h2
                className={cx(
                    "text-align--center--mobile",
                    "letter-spacing-s",
                    "text-font-size-l"
                )}>
                <span>
                    {`Compare ${renderProductsText(productList)} from ${
                        numberOfPolicies || "_"
                    } top providers.`}
                </span>
            </h2>
        );
    }

    return (
        <h2
            className={cx(
                "layout-flex-row--justify-centered",
                "text-product-sort",
                "gap-4xl"
            )}>
            <span className="space-s">
                {`${numberOfPolicies || "_"} policies `}
                <span className="layout-hidden-mobile">sorted by</span>
            </span>
            <Dropdown
                name="productPageSortBy"
                variant="product-sort"
                selectedOptionId={sortBy}
                options={sortByDropdown}
                onChange={(i) => handleChangeSortBy(i.target.value as SortBy)}
                noMargin
            />
        </h2>
    );
};

export default SortBySummary;
